import React, { useEffect, useState, useContext, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import InputMask from 'react-input-mask';
import Pagination from '../Common/Pagination';
import Swal from 'sweetalert2';
import { Context } from '../../context/UserContext';
import moment from "moment-jalali";
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import ReactSelect from 'react-select';

const Index = () => {

    const context = useContext(Context);
    const { readData } = useEntityCrud('ServiceConsumer/GetAllServiceConsumer');
    const { readDataByFilter: readDataGroup } = useEntityCrud('Group/GetAllGroups')
    const { readDataByFilter: readDataService } = useEntityCrud('Service/GetAllServices')
    const { readDataByFilter: readDataSubService } = useEntityCrud('SubService/GetAllSubservices')
    const { readData: readDataBusiness } = useEntityCrud('Business/GetAllBusiness')
    const { addData: changeStatus } = useEntityCrud('ServiceConsumer/changeServiceConsumer');
    const { addData: updateServiceConsumers } = useEntityCrud('ServiceConsumer/UpdateServiceConsumer');
    const { readData: searchDeliveries } = useEntityCrud('Business/getDeliverAgents');


    const [statusLevel, setStatusLevel] = useState(0);
    const [lastPage,setLastPage] = useState(0);

    const [businessList, setBusinessList] = useState([]);
    const [businessId, setBusinessId] = useState(0);
    const [groupList, setGroupList] = useState([]);
    const [serviceList, setServiceList] = useState([]);
    const [subServiceList, setSubServiceList] = useState([]);
    const [storageItemBusiness, setStorageItemBusiness] = useState([])
    const [storageItemGroup, setStorageItemGroup] = useState([])
    const [storageItemService, setStorageItemService] = useState([])
    const [orgAddress, setOrgAddress] = useState({
        buisnessId: "",
        groupId: "",
        serviceId: "",
        subServiceId: ""
    })

    const navigate = useNavigate();
    let userDataBusinessId = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')).businessId : {};


    const [rows, setRows] = useState([]);
    const [rowsDeliver, setRowsDeliver] = useState([]);

    const [pages, setPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pan, setPan] = useState('');
    const [nationalCode, setNationalCode] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [serviceConsumerId, setServiceConsumerId] = useState(0);
    const [deliverId, setDeliverId] = useState(0);
    const [consumerNationalCode, setConsumerNationalCode] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [showLoading, setShowLoading] = useState(false);
    const [searched, setSearched] = useState(false);
    const [deliveryModal, setDeliveryModal] = useState(false);
    const [visible, setVisible] = useState(true)
    const [isSerachMode, setIsSerachMode] = useState(false)

    const [deliverPreparationTime, setDeliverPreparationTime] = useState('');
    const [count,setCount] = useState(0);



    const [userDetails, setUserDetails] = useState({
        delivername: '',
        deliverlastname: '',
        delivermobile: '',
        nationalCode: '',
        delivervehicle1: '',
        delivervehicle2: '',
        deliverPreparationTime: ''
    });



    const getData = (searchData) => {
        debugger
        setShowLoading(true);
        const postedData = {
            offset: 0,
            limit: 10,
            ...searchData
        };

        if (searchData === undefined) {
            postedData.fromDate = convertToDate(getToday());
            postedData.toDate = convertToDate(getToday());
        }
        if(businessId)
            postedData.businessId = businessId;
        readData(postedData).then(res => {
            debugger
            if (res.data.status) {
                calcPages(res);
                setRows(res.data.result);
            } else {
                setRows([]);
                setPages([]);
            }
            setShowLoading(false);
        })
    }

    useEffect(() => {
        getData();

        const postedData = {
            "businessId": userDataBusinessId ? userDataBusinessId[0] : 0,
        }
        searchDeliveries(postedData).then(({ data }) => {
            debugger
            if (data.status) {
                setRowsDeliver(data.result.filter(item => item.isActive === true).map(item => ({
                    value: item.id,
                    label: item.person.name + " " + item.person.lastName,
                    delivername: item.person.name,
                    deliverlastname: item.person.lastName,
                    delivermobile: item.person.cellphone,
                    delivervehicle: item.vehicleNo,
                })))
            }
            else {
                toast.error(data.message)
                setRowsDeliver({})
            }
        })

    }, [])

    const calcPages = res => {
        let calcPages = res.data.count / 10;
        setCount(res.data.count)

        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setLastPage(pagesArray.length)
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const changePage = (e, page) => {
        e.preventDefault();
        setShowLoading(true);

        setCurrentPage(page);
        const postedData = {
            limit: 10,
            offset: page - 1
        };
        
        if (fromDate)
            postedData.fromDate = convertToDate(fromDate);
        else
            postedData.fromDate = convertToDate(getToday());
        if (toDate)
            postedData.toDate = convertToDate(toDate);
        else
            postedData.toDate = convertToDate(getToday());
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (pan)
            postedData.pan = pan;
        readData(postedData).then(res => {
            setShowLoading(false);

            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const prevPage = e => {
        setShowLoading(true);
        e.preventDefault();
        setCurrentPage(currentPage - 1);
        const postedData = {
            limit: 10,
            offset: currentPage - 2
        };
        
        if (fromDate)
            postedData.fromDate = convertToDate(fromDate);
        else
            postedData.fromDate = convertToDate(getToday());
        if (toDate)
            postedData.toDate = convertToDate(toDate);
        else
            postedData.toDate = convertToDate(getToday());
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (pan)
            postedData.pan = pan;
        readData(postedData).then(res => {
            setShowLoading(false);

            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const nextPage = e => {
        setShowLoading(true);

        e.preventDefault();
        setCurrentPage(currentPage + 1);
        const postedData = {
            limit: 10,
            offset: currentPage
        };
        
        if (fromDate)
            postedData.fromDate = convertToDate(fromDate);
        else
            postedData.fromDate = convertToDate(getToday());
        if (toDate)
            postedData.toDate = convertToDate(toDate);
        else
            postedData.toDate = convertToDate(getToday());
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (pan)
            postedData.pan = pan;
        readData(postedData).then(res => {
            setShowLoading(false);
            setRows(res.data.result);
        }).catch(err => err.data.errors.map(error => toast.error(error.message)));
    }

    const searchData = e => {
        debugger
        setIsSerachMode(true)
        e.preventDefault();
        const postedData = {};
        if (fromDate)
            postedData.fromDate = convertToDate(fromDate);
        if (toDate)
            postedData.toDate = convertToDate(toDate);
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (consumerNationalCode)
            postedData.consumerNationalCode = consumerNationalCode;
        if (mobileNo)
            postedData.mobile = mobileNo;
        if (pan)
            postedData.pan = pan;
        if (serviceConsumerId)
            postedData.serviceConsumerId = parseInt(serviceConsumerId);
        if (orgAddress.subServiceId)
            postedData.subServiceId = [orgAddress.subServiceId.value];

        getData(postedData);
        setSearched(true);
    }

    const clearSearch = e => {
        e.preventDefault();
        setPan('');
        setFromDate('');
        setToDate('');
        setNationalCode('');
        setSearched(false);

        const postedData = {};
        postedData.fromDate = convertToDate(getToday());
        postedData.toDate = convertToDate(getToday());

        getData(postedData);

        setOrgAddress({
            buisnessId: "",
            groupId: "",
            serviceId: "",
            subServiceId: ""
        })

        setConsumerNationalCode("")
    }


    function convertToDate(date) {
        if (!date)
            return ""
        return moment(`${date.year}/${date.month}/${date.day}`, "jYYYY/jMM/jDD").format("jYYYYjMMjDD");
    }

    function getToday() {
        const today = moment().format("jYYYY-jMM-jDD").split("-")
        return {
            year: +today[0],
            month: +today[1],
            day: +today[2]
        }
    }

    const downloadExcelFile = () => {
        toast.info('در حال آماده سازی . لطفاً صبر کنید ...');

        const postedData = {
            limit: 1000,
            offset: 0,
            fromDate: convertToDate(fromDate) || convertToDate(getToday()),
            toDate: convertToDate(toDate) || convertToDate(getToday())
        };
        if (nationalCode)
            postedData.nationalCode = nationalCode;
        if (pan)
            postedData.pan = pan;


        readData(postedData).then(({ data }) => {
            if (data.result) {
                let csvString = 'خریدار,کسب و کار,مبلغ کل,مبلغ تخفیف, مبلغ پرداخت شده, روش پرداخت,تاریخ ,  شماره کارت,شماره فاکتور\r';
                let csvItemString = []
                data.result?.map(item => {
                    csvItemString.push({ ...item, date: item.registerDate.toString().slice(0, 4) + '-' + item.registerDate.toString().slice(4, 6) + '-' + item.registerDate.toString().slice(6, 8) + ' ' + (item.registerTime || '-') })
                })
                csvItemString?.map(row => {
                    csvString += `${row.personFullName || "-"},${row.businessTitle || "-"},${row.totalAmount || "-"},${row.totalDiscount || "-"},${row.totalPay || "-"},${row.payment_Type},${row.date || "-"},${row.pan || "-"},${row.serviceConsumerId || "-"}\r`;
                });
                let universalBOM = '\uFEFF';
                let a = window.document.createElement('a');
                a.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(universalBOM + csvString));
                let fileName = 'report-export.csv';
                a.setAttribute('download', fileName);
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
            }
        })
    }

    useEffect(() => {
        
        readDataBusiness({offset: 0,limit: 5000}).then(res => {
            setBusinessList(res.data.result)
        });
    }, [])

    const businessAll = useMemo(() => businessList
        .map(item => ({ value: item.id, label: item.title, isActive: item.isActive })));
    const groupAll = useMemo(() => groupList
        .map(item => ({ value: item.id, label: item.title, isActive: item.isActive })));
    const serviceAll = useMemo(() => serviceList
        .map(item => ({ value: item.id, label: item.title, isActive: item.isActive })));
    const subServiceAll = useMemo(() => subServiceList
        .map(item => ({ value: item.id, label: item.title, isActive: item.isActive })));

    useEffect(() => {
        const postedData = {
            buisnessId: orgAddress.buisnessId.value || parseInt(localStorage.getItem("buinessID")),
        };
        readDataGroup(postedData).then(res => {
            setGroupList(res.data.result)
            console.log(groupList);
        });
    }, [businessList, orgAddress.buisnessId])


    useEffect(() => {
        const postedData = {
            groupId: orgAddress.groupId.value || parseInt(localStorage.getItem("groupID")),
        };
        readDataService(postedData).then(res => {
            setServiceList(res.data.result)
        });
    }, [orgAddress.groupId.value])


    useEffect(() => {
        const postedData = {
            serviceId: orgAddress.serviceId.value || parseInt(localStorage.getItem("serviceId")),
        };
        readDataSubService(postedData).then(res => {
            setSubServiceList(res.data.result)
        });
    }, [orgAddress.serviceId.value])


    useEffect(() => {

        const searchDetailsBusinessId = parseInt(localStorage.getItem("buinessID"));
        setStorageItemBusiness({
            value: businessAll?.find(it => it.value === searchDetailsBusinessId),
            label: businessAll?.find(it => it.value === searchDetailsBusinessId)?.label
        })

        const searchDetailsGroupId = parseInt(localStorage.getItem("groupID"));
        setStorageItemGroup({
            value: groupAll?.find(it => it.value === searchDetailsGroupId),
            label: groupAll?.find(it => it.value === searchDetailsGroupId)?.label
        })

        const searchDetailsServiceId = parseInt(localStorage.getItem("serviceID"));
        setStorageItemService({
            value: serviceAll?.find(it => it.value === searchDetailsServiceId),
            label: serviceAll?.find(it => it.value === searchDetailsServiceId)?.label
        })

    }, [businessList])

    const handleChangeBusiness = (value) => {

        localStorage.removeItem("buinessID");
        localStorage.removeItem("groupID");
        localStorage.removeItem("serviceID");

        setOrgAddress(prevState => ({ ...prevState, serviceId: "" }))
        setOrgAddress(prevState => ({ ...prevState, groupId: "" }))
        setOrgAddress(prevState => ({ ...prevState, buisnessId: value }))
        console.log(value);
        setBusinessId(value.value)

        setStorageItemGroup({
            value: "",
            label: ""
        })

        setStorageItemService({
            value: "",
            label: ""
        })
    }


    const handleChangeGroup = (value) => {

        localStorage.removeItem("groupID");
        localStorage.removeItem("serviceID");

        setOrgAddress(prevState => ({ ...prevState, serviceId: "" }))
        setOrgAddress(prevState => ({ ...prevState, groupId: value }))

        setStorageItemService({
            value: "",
            label: ""
        })
    }

    const handleChangeService = (value) => {
        setOrgAddress(prevState => ({ ...prevState, serviceId: value }))
    }

    const handleChangeSubService = (value) => {
        setOrgAddress(prevState => ({ ...prevState, subServiceId: value }))
    }

    const handleStatusType = (consumerId, statusId, currentPage) => {
        debugger
        const postedData0 = {
            "offset": currentPage,
            "limit": 10,
            "serviceConsumerId": consumerId,
            "status": statusId
        };
        changeStatus(postedData0).then(({ data }) => {
            debugger
            if (data.status) {
                if (statusId === 4) {
                }
                else {
                    toast.success(' وضعیت با موفقیت ثبت شد. ');
                    if (isSerachMode) {
                        const postedData = {
                            "offset": currentPage,
                            "limit": 10,
                        };
                        if (fromDate)
                            postedData.fromDate = convertToDate(fromDate);
                        if (toDate)
                            postedData.toDate = convertToDate(toDate);
                        if (nationalCode)
                            postedData.nationalCode = nationalCode;
                        if (consumerNationalCode)
                            postedData.consumerNationalCode = consumerNationalCode;
                        if (mobileNo)
                            postedData.mobile = mobileNo;
                        if (pan)
                            postedData.pan = pan;
                        if (serviceConsumerId)
                            postedData.serviceConsumerId = parseInt(serviceConsumerId);
                        if (orgAddress.subServiceId)
                            postedData.subServiceId = [orgAddress.subServiceId.value];
                        readData(postedData).then(res => {
                            debugger
                            if (res.data.status) {
                                calcPages(res);
                                setRows(res.data.result);
                            } else {
                                setRows([]);
                                setPages([]);
                            }
                            setShowLoading(false);
                        })
                        setSearched(true);

                    } else {
                        const postedData = {
                            "offset": currentPage,
                            "limit": 10,
                            fromDate: convertToDate(getToday()),
                            toDate: convertToDate(getToday())
                        };
                        getData(postedData);
                        setSearched(true);
                    }


                }

            } else {
                toast.error(data.message);

            }
        })
    }

    const updateServiceConsuer = (consumerId, statusId) => {
        debugger
        const postedData = {
            "offset": 0,
            "limit": 0,
            "personId": 0,
            "registerDate": 0,
            "subServiceId": [
                0
            ],
            "serviceConsumerId": 0,
            "status": 0,
            "businessId": userDataBusinessId[0],
            "totalAmount": 0,
            "totalDiscount": 0,
            "totalPay": 0,
            "addressId": 0,
            "serviceConsumerId": consumerId,
            "delivername": deliverId.delivername,
            "deliverlastname": deliverId.deliverlastname,
            "delivermobile": deliverId.delivermobile,
            "delivervehicle": deliverId.delivervehicle,
            "deliverPreparationTime": deliverPreparationTime,
            "status": statusId,
            "additionalInfo": [
                {
                    "key": "",
                    "value": ""
                }
            ]
        };

        updateServiceConsumers(postedData).then(({ data }) => {
            debugger
            if (data.status) {
                toast.success('  اطلاعات با موفقیت ایجاد شد');
                if (isSerachMode) {
                    const postedData = {};
                    if (fromDate)
                        postedData.fromDate = convertToDate(fromDate);
                    if (toDate)
                        postedData.toDate = convertToDate(toDate);
                    if (nationalCode)
                        postedData.nationalCode = nationalCode;
                    if (consumerNationalCode)
                        postedData.consumerNationalCode = consumerNationalCode;
                    if (mobileNo)
                        postedData.mobile = mobileNo;
                    if (pan)
                        postedData.pan = pan;
                    if (serviceConsumerId)
                        postedData.serviceConsumerId = parseInt(serviceConsumerId);
                    if (orgAddress.subServiceId)
                        postedData.subServiceId = [orgAddress.subServiceId.value];
                    getData(postedData);
                    setSearched(true);
                    setVisible(false)
                    setDeliverId({})
                    setDeliverPreparationTime("")

                } else {
                    const postedData = {
                        offset: 0,
                        limit: 10,
                        fromDate: convertToDate(getToday()),
                        toDate: convertToDate(getToday())
                    };
                    getData(postedData);
                    setSearched(true);
                    setVisible(false)
                    setDeliverId({
                        value: 0,
                        label: "",
                        delivername: "",
                        deliverlastname: "",
                        delivermobile: "",
                        delivervehicle: ""
                    })
                    setDeliverPreparationTime("")
                }
            } else {
                toast.error(data.message);

            }
        })
    }



    return (
        <div className="card">
            <div className="card-body">
                {showLoading ? <div className="loading-box">
                    <img src="/assets/images/loading.gif" alt="" />
                </div> : ''}
                <div className='d-flex'>
                    {context.checkHasPermission('create') ? <Link className="btn btn-primary" to="create">ثبت سفارش جدید</Link> : ''}
                    {/* <button className="btn btn-warning mx-2  d-none d-sm-block" onClick={e => getData({})}>به روزرسانی لیست</button>
 */}                    <button className="btn btn-dark mx-2 accordion-toggle collapsed  d-none d-sm-block"
                        data-bs-toggle="collapse"
                        data-bs-parent="#accordion"
                        href="#collapseFour"
                        aria-expanded="false">جستجو</button>
                </div>
                <div className="panel-group1" id="accordion1">
                    <div id="collapseFour" className="panel-collapse collapse position-relative" role="tabpanel" aria-expanded="false">

                        <form onSubmit={e => searchData(e)} className="row mt-4">

                            <div className="col-md-2 p-0 deskTopShow" style={{ position: "relative", zIndex: "9" }}>
                                <div className="form-group">
                                    <label htmlFor="fromDate"> از تاریخ     </label><br />
                                    {fromDate && <i class="fe fe-x clear-select-btn" onClick={() => setFromDate(null)} style={{left: 25}}></i>}
                                    <DatePicker
                                        name="fromDate"
                                        required
                                        locale="fa"
                                        shouldHighlightWeekends
                                        value={fromDate}
                                        calendarPopperPosition={"bottom"}
                                        onChange={setFromDate}
                                        className="form-control"
                                        inputPlaceholder=' تاریخ  را انتخاب کنید ...'
                                    />
                                </div>
                            </div>
                            <div className="col-md-2 p-0" style={{ position: "relative", zIndex: "8" }}>
                                <div className="form-group">
                                    <label htmlFor="toDate"> تا تاریخ       </label><br />
                                    {toDate && <i class="fe fe-x clear-select-btn" onClick={() => setToDate(null)} style={{left: 25}}></i>}
                                    <DatePicker
                                        name="toDate"
                                        required
                                        locale="fa"
                                        shouldHighlightWeekends
                                        value={toDate}
                                        calendarPopperPosition={"bottom"}
                                        onChange={setToDate}
                                        className="form-control"
                                        inputPlaceholder='  تاریخ را انتخاب کنید ...'
                                    />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>کد ملی</label>
                                    <input type="tel" className="form-control ltr-input" value={nationalCode} onChange={e => setNationalCode(e.target.value)} maxLength={10} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>شماره همراه</label>
                                    <input type="tel" className="form-control ltr-input" value={mobileNo} onChange={e => setMobileNo(e.target.value)} maxLength={11} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>شماره فاکتور</label>
                                    <input type="tel" className="form-control ltr-input" value={serviceConsumerId} onChange={e => setServiceConsumerId(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>کد ملی استفاده کننده</label>
                                    <input type="tel" className="form-control ltr-input" value={consumerNationalCode} onChange={e => setConsumerNationalCode(e.target.value)} maxLength={10} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>شماره کارت (6 رقم از سمت راست)</label>
                                    <input type="tel" className="form-control ltr-input" value={pan} onChange={e => setPan(e.target.value)} maxLength={6} />
                                </div>
                            </div>


                            <div className="col-md-2">
                                <label>
                                    کسب و کار
                                </label>
                                {!!orgAddress.buisnessId && <i className="fe fe-x clear-select-btn" onClick={() => setOrgAddress({...orgAddress,buisnessId: 0})}></i>}
                                <ReactSelect label="   کسب و کار"
                                    options={businessAll.filter(item => item.isActive === true)}
                                    value={orgAddress.buisnessId || storageItemBusiness}
                                    onChange={handleChangeBusiness}
                                    placeholder="انتخاب کنید"
                                    name="buisnessId"
                                />
                            </div>
                            {!!orgAddress.buisnessId && <div className="col-md-2">
                                <label>
                                    گروه
                                </label>
                                {!!orgAddress.groupId && <i className="fe fe-x clear-select-btn" onClick={() => setOrgAddress({...orgAddress,groupId: 0})}></i>}
                                <ReactSelect label="گروه"
                                    options={groupAll.filter(item => item.isActive === true)}
                                    placeholder="انتخاب کنید"
                                    name="groupId"
                                    value={orgAddress.groupId || storageItemGroup}
                                    onChange={handleChangeGroup}
                                />
                            </div>}
                            {!!orgAddress.groupId && <div className="col-md-2">
                                <label>
                                    سرویس
                                </label>
                                {!!orgAddress.serviceId && <i className="fe fe-x clear-select-btn" onClick={() => setOrgAddress({...orgAddress,serviceId: 0})}></i>}
                                <ReactSelect label="سرویس"
                                    options={serviceAll.filter(item => item.isActive === 1)}
                                    placeholder="انتخاب کنید"
                                    name="serviceId"
                                    value={orgAddress.serviceId || storageItemService}
                                    onChange={handleChangeService}
                                />
                            </div>}
                            {!!orgAddress.serviceId && <div className="col-md-2">
                                <label>
                                    محصول
                                </label>
                                {!!orgAddress.subServiceId && <i className="fe fe-x clear-select-btn" onClick={() => setOrgAddress({...orgAddress,subServiceId: 0})}></i>}
                                <ReactSelect label="محصول"
                                    options={subServiceAll.filter(item => item.isActive === 1)}
                                    placeholder="انتخاب کنید"
                                    name="subServiceId"
                                    value={orgAddress.subServiceId || storageItemService}
                                    onChange={handleChangeSubService}
                                />
                            </div>}


                            <div className="col-md-4" style={{ marginTop: 30 }}>
                                <button className="btn btn-success me-2">جستجو</button>
                                {searched ? <button className="btn btn-danger" onClick={clearSearch} type="button">بازنشانی</button> : ''}
                            </div>
                        </form>

                    </div>
                </div>

                <hr className="mb-3" />
                {rows?.length ?
                    <div className="row">
                        {rows.map((item, index) => (
                            <div className="col-md-6" key={index}>
                                <div className="card custom-border-1">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <p className="buyer-name">خریدار: {item.personFullName}</p>
                                            <p className="business-title">کسب و کار: {item.businessTitle}</p>
                                            <p className="total-amount">مبلغ کل: {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(item.totalAmount)} ریال</p>
                                            <p className="discount-amount">مبلغ تخفیف: {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(item.totalDiscount)} ریال</p>
                                            <p className="business-title">  شماره فاکتور : {item.serviceConsumerId}</p>
                                            <p >
                                                وضعیت :
                                                <span
                                                    className={`mx-1 ${item.statusTitle === "منتظر تایید" ? "badge bg-warning px-3 py-1" :
                                                        item.statusTitle === "ثبت درخواست" ? "badge bg-secondary px-3  py-1" :
                                                            item.statusTitle === "لغو شده" ? "badge bg-danger px-3  py-1" :
                                                                "badge bg-success px-3"}`}
                                                > {item.statusTitle}
                                                </span>
                                            </p>
                                        </div>
                                        <div className="col-md-6">
                                            <p className="paid-amount">مبلغ پرداخت شده: {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(item.totalPay)} ریال</p>
                                            <p className="payment-type">روش پرداخت: {item.payment_Type} </p>
                                            <p className="card-number" >  شماره کارت :<span dir="ltr">{item.pan}</span></p>
                                            <p className="created-time"  >تاریخ و ساعت :<span dir="ltr">
                                                {(item.registerDate == null ?
                                                    '-' :
                                                    (item.registerDate.toString().slice(0, 4) + '-' + item.registerDate.toString().slice(4, 6) + '-' + item.registerDate.toString().slice(6, 8))) + ' ' + (item.registerTime || '-')}
                                            </span></p>

                                        </div>
                                    </div>

                                    <div className="operation-btn-group d-flex justify-content-between">
                                        <div className='d-flex align-items-center'>

                                            {/*                                             {item.statuses.statuses.filter(s => s.id !== 6).filter(d => d.id > item.status).sort((a, b) => a.id - b.id).map(it => (
 */}
                                            <>

                                                {item.status === 1 && <button onClick={() => handleStatusType(item.serviceConsumerId, 2, currentPage)}
                                                    title="منتظر تایید"
                                                    className="btn btn-icon me-1 mb-0 btn-warning">
                                                    <i className="fa fa-hourglass-start"></i>
                                                </button>}

                                                {item.status === 2 && <button
                                                    onClick={() => handleStatusType(item.serviceConsumerId, 3, currentPage)}
                                                    title="تایید شده و در حال آماده سازی"
                                                    className="btn btn-icon me-1 mb-0 btn-success">
                                                    <i className="fa fa-check"></i>
                                                </button>}

                                                {item.status === 3 && <button
                                                    onClick={() => handleStatusType(item.serviceConsumerId, 4, currentPage)}
                                                    data-bs-toggle="collapse"
                                                    href={`#collapseFour0${item.serviceConsumerId}`}
                                                    data-bs-parent="#accordion"
                                                    aria-expanded="false"
                                                    title="ارسال شده"
                                                    className="btn btn-icon me-1 mb-0 btn-secondary">
                                                    <i className="fa fa-motorcycle"></i>
                                                </button>}

                                                {item.status === 4 && <button onClick={() => handleStatusType(item.serviceConsumerId, 5, currentPage)}
                                                    title="تحویل شده"
                                                    className="btn btn-icon me-1 mb-0 btn-primary">
                                                    <i className="fa fa-hand-grab-o"></i>
                                                </button>}

                                                {item.status === 2 && <button onClick={() => handleStatusType(item.serviceConsumerId, 6, currentPage)}
                                                    title="لغو شده"
                                                    className="btn btn-icon me-1 mb-0 btn-danger">
                                                    <i className="fa fa-close"></i>
                                                </button>}

                                                {/*                                         
                                                      <button onClick={() => handleStatusType(item.serviceConsumerId, it.id)}
                                                        title={it.title}
                                                        data-bs-toggle="collapse"
                                                        href={`#collapseFour0${item.serviceConsumerId}`}
                                                        data-bs-parent="#accordion"
                                                        aria-expanded="false"

                                                        className={`accordion-toggle collapsed  btn btn-icon me-1 mb-0 ${it.id === 1 ? "btn-info" :
                                                            it.id === 2 ? "btn-warning" :
                                                                it.id === 3 ? "btn-success" :
                                                                    it.id === 4 ? "btn-secondary" :
                                                                        it.id === 5 ? "btn-primary" : ""}`}>

                                                        <i className={`fa ${it.id === 1 ? "fa-sticky-note-o" :
                                                            it.id === 2 ? "fa-hourglass-start" :
                                                                it.id === 3 ? "fa-check" :
                                                                    it.id === 4 ? "fa-motorcycle" :
                                                                        it.id === 5 ? "fa-hand-grab-o" : ""}`}></i>
                                                    </button> */}
                                            </>




                                        </div>

                                        <div>
                                            {context.checkHasPermission('read') ? <Link to={'/service-consumer/view/' + item.serviceConsumerId} title="مشاهده" className="btn btn-icon me-1 mb-0 btn-primary"><i className="fe fe-eye"></i></Link> : ''}
                                            {context.checkHasPermission('read') ? <Link to={'/service-consumer/factor/' + item.serviceConsumerId} title="چاپ فاکتور" target="_blank" className="btn btn-icon mb-0 btn-info  me-1"><i className="fe fe-printer"></i></Link> : ''}
                                        </div>
                                    </div >
                                    {visible && <div className="panel-group1" >
                                        <div id={`collapseFour0${item.serviceConsumerId}`}
                                            className="panel-collapse collapse position-relative"
                                            role="tabpanel"
                                            aria-expanded="false">


                                            <div className="row py-4 d-flex align-items-center" style={{ textAlign: "right" }}>
                                                <div className="col-md-5">
                                                    <div className="form-group">
                                                        <ReactSelect label=" پیک "
                                                            options={rowsDeliver}
                                                            value={deliverId}
                                                            onChange={(value) => setDeliverId(value)}
                                                            placeholder="  پیک مورد نظر را انتخاب کنید  :"
                                                            name="deliverId"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <input type="number"
                                                            min={0} maxLength={4}
                                                            placeholder='مدت زمان تحویل'
                                                            className="form-control" value={deliverPreparationTime}
                                                            onChange={e => setDeliverPreparationTime(e.target.value)} />
                                                    </div>
                                                </div>
                                                <button className="col-md-2 btn btn-success mb-4 mt-0 btn-block btn-without-label"
                                                    onClick={() => updateServiceConsuer(item.serviceConsumerId, 4)} > ثبت پیک </button>
                                            </div>

                                        </div>
                                    </div>}
                                </div>
                            </div>
                        ))}

                        <div className="col-12 d-flex justify-content-between">
                        <p>تعداد کل ردیف ها : {count || 0}</p>

                            <Pagination changePage={changePage} currentPage={currentPage} pages={pages} prevPageClick={prevPage} nextPageClick={nextPage} lastPage={lastPage} />
                            <button className="btn btn-success mt-4" onClick={downloadExcelFile}>دریافت خروجی اکسل</button>
                        </div>

                    </div>
                    : <div className="alert alert-info"><p>داده ای یافت نشد</p></div>}
            </div>
        </div >
    );
}

export default Index;